import { useTRPC } from "@/lib/trpc.js";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export default function OrganizationsList() {
  const trpc = useTRPC();

  const { data, isLoading, isError } = useQuery(
    trpc.organizations.list.queryOptions(),
  );

  if (isError) return <div>Error</div>;
  if (isLoading) return <div>Loading...</div>;

  return (
    <div>
      <h1>Organizations</h1>
      <ul>
        {data?.map((organization) => (
          <li key={organization.id}>{organization.name}</li>
        ))}
      </ul>
    </div>
  );
}

export const Route = createFileRoute(
  "/_authenticated/super-admin/organizations/list",
)({
  component: OrganizationsList,
});
